"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M349.4 141c-43.5 0-81 25.3-98.7 62-17.7-36.7-55.3-62-98.7-62-60.5 0-109.6 49.1-109.6 109.6S91.5 360.2 152 360.2c43.5 0 81-25.3 98.7-62 17.7 36.7 55.3 62 98.7 62 60.5 0 109.6-49.1 109.6-109.6S409.9 141 349.4 141zM192.7 276c4.3 4.3 4.3 11.2 0 15.5-4.3 4.3-11.2 4.3-15.5 0l-25.3-25.3-25.3 25.3c-4.3 4.3-11.2 4.3-15.5 0-4.3-4.3-4.3-11.2 0-15.5l25.3-25.3-25.3-25.3c-4.3-4.3-4.3-11.2 0-15.5 4.3-4.3 11.2-4.3 15.5 0l25.3 25.3 25.3-25.3c4.3-4.3 11.2-4.3 15.5 0 4.3 4.3 4.3 11.2 0 15.5l-25.3 25.3 25.3 25.3zm214.5-50.3l-72 71.9c-4.3 4.3-11.2 4.3-15.5 0l-39.2-39.1c-4.3-4.3-4.3-11.2 0-15.5 4.3-4.3 11.2-4.3 15.5 0l31.4 31.4 64.2-64.2c4.3-4.3 11.2-4.3 15.5 0 4.4 4.2 4.4 11.2.1 15.5z"
  });
};

exports.default = _default;